// Recharge Subscription Savings Solution by https://netsuccessmarketing.com
document.addEventListener('DOMContentLoaded', function() {
    // Only run on Shopify product pages
    if (!document.body.classList.contains('template-product')) {
        return;
    }
    
    // Check if required container exists
    const descriptionContainer = document.getElementById('ETP_VARIANT_DESCRIPTION');
    if (!descriptionContainer) {
        return;
    }
    
    // Create savings display element
    const savingsDisplay = document.createElement('div');
    savingsDisplay.id = 'recharge-savings-display';
    
    // Apply styles through JavaScript
    savingsDisplay.style.display = 'block';
    savingsDisplay.style.padding = '12px 15px';
    savingsDisplay.style.marginBottom = '15px';
    savingsDisplay.style.borderLeft = '4px solid #4CAF50';
    savingsDisplay.style.backgroundColor = '#e8f5e9';
    savingsDisplay.style.color = '#2c3e50';
    savingsDisplay.style.fontWeight = '600';
    savingsDisplay.style.fontSize = '18px';
    savingsDisplay.style.borderRadius = '4px';
    savingsDisplay.style.transition = 'all 0.3s ease';
    savingsDisplay.style.opacity = '0';
    savingsDisplay.style.transform = 'translateY(-10px)';
    
    // Insert at the top of container
    descriptionContainer.insertBefore(savingsDisplay, descriptionContainer.firstChild);
    
    // Main synchronization function
    function syncSavings() {
        try {
            // Find Recharge widget
            const widget = document.querySelector('recharge-subscription-widget');
            if (!widget || !widget.shadowRoot) {
                return;
            }
            
            const shadowRoot = widget.shadowRoot;
            
            // Get price elements using part attributes
            const subscriptionPriceEl = shadowRoot.querySelector('span[part="rc-purchase-option__discounted-price"]');
            const onetimePriceEl = shadowRoot.querySelector('span[part="rc-purchase-option__price"]');
            
            // Validate price elements
            if (!subscriptionPriceEl || !onetimePriceEl) {
                return;
            }
            
            // Extract and parse prices
            const subPriceText = subscriptionPriceEl.textContent.trim();
            const oneTimePriceText = onetimePriceEl.textContent.trim();
            
            const subPrice = parseFloat(subPriceText.replace(/[^\d.]/g, ''));
            const oneTimePrice = parseFloat(oneTimePriceText.replace(/[^\d.]/g, ''));
            
            if (isNaN(subPrice) || isNaN(oneTimePrice)) {
                return;
            }
            
            // Check if subscription is selected
            const subscriptionOption = shadowRoot.querySelector('.rc-purchase-option__subscription');
            const isSubscriptionSelected = 
                subscriptionOption && 
                (subscriptionOption.hasAttribute('rc-selected') || 
                 subscriptionOption.classList.contains('rc-purchase-option__selected'));
            
            // Calculate savings
            const savings = (oneTimePrice - subPrice).toFixed(2);
            
            if (isSubscriptionSelected) {
                // Show savings display
                savingsDisplay.textContent = `Save $${savings} with Autoship!`;
                savingsDisplay.style.display = 'block';
                
                // Animate in
                setTimeout(() => {
                    savingsDisplay.style.opacity = '1';
                    savingsDisplay.style.transform = 'translateY(0)';
                }, 10);
            } else {
                // Animate out
                savingsDisplay.style.opacity = '0';
                savingsDisplay.style.transform = 'translateY(-10px)';
                
                // Hide after animation completes
                setTimeout(() => {
                    savingsDisplay.style.display = 'none';
                }, 300);
            }
            
        } catch (error) {
            console.error('Savings sync error:', error);
        }
    }
    
    // Run synchronization every 800ms
    const syncInterval = setInterval(syncSavings, 800);
    
    // Initial sync after 2 seconds
    setTimeout(syncSavings, 2000);
    
    // Clean up on page navigation
    window.addEventListener('beforeunload', function() {
        clearInterval(syncInterval);
    });
});